import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import DownloadIcon from "@mui/icons-material/Download";
import AssignmentIcon from "@mui/icons-material/Assignment";
import {
  Box,
  Button,
  Card,
  Dialog,
  DialogContent,
  DialogTitle,
  Drawer,
  Grid,
  Icon,
  List,
  ListItem,
  ListItemText,
  Typography,
  useTheme,
  Tabs,
  Tab,
  Chip,
} from "@mui/material";
import axios, { AxiosError } from "axios";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  getMedicalRecords,
  getSessionById,
  joinSession,
  postDuration,
  updateSession,
  uploadMedicalRecord,
  downloadMedicalRecord,
  getPatientHistory,
} from "../../../../api/services/api";
import {
  StyledDrawerContent,
  StyledDrawerHeader,
} from "../../../../components/DrawerTemplate";
import Loader from "../../../../components/Loader";
import { GenerateReportForm } from "./GenerateReportForm";
import { SessionDetailCard } from "./SessionDetailCard";
import VoiceExerciseSummary from "../../Patients/VoiceExerciseSummary";
import { useCallback } from "react";

export const SessionView = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { id } = useParams();
  const [filterData] = useState(id);
  const [startSession, setStartSession] = useState(false);
  const [patientProfileId, setpatientProfileId] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [open, setOpen] = useState(false);
  const [checkJoinSession, setCheckJoinSession] = useState(false);
  const [currentTime] = useState(
    moment().format("YYYY-MM-DD HH:mm")
  );
  const [joinResponse, setJoinResponse] = useState<any>();
  const [homeSession, setHomeSession] = useState(false);
  const [checkOtp, setCheckOtp] = useState(false);
  const [otp, setOtp] = useState("");
  const queryClient = useQueryClient();
  const [totalSeconds, setTotalSeconds] = useState(0);
  const [userJoin, setUserJoin] = useState(false);

  const toggleDrawer = (newOpen: any) => {
    setOpen(newOpen);
  };

  const { data, isLoading, refetch } = useQuery(
    ["sessions", filterData],
    getSessionById,
    {
      refetchInterval: 30000, // Refetch every 30 seconds to get updated meeting links
      refetchOnWindowFocus: true, // Refetch when window gains focus
    }
  );

  // Manual refresh function for debugging meeting links
  const handleRefreshSession = async () => {
    console.log('Manually refreshing session data...');
    toast.info('Refreshing session data...');
    try {
      await refetch();
      toast.success('Session data refreshed successfully');
    } catch (error) {
      console.error('Error refreshing session data:', error);
      toast.error('Failed to refresh session data');
    }
  };

  const { data: getMedicalRecordsData } = useQuery(
    [
      "medical-record",
      {
        patientProfileId: patientProfileId,
      },
    ],
    getMedicalRecords,
    {
      enabled: Boolean(patientProfileId),
    }
  );

  const { data: patientHistoryData } = useQuery(
    ["patient-history", patientProfileId],
    getPatientHistory,
    {
      enabled: Boolean(patientProfileId),
    }
  );

  useQuery(
    [
      "join-session",
      {
        id: id,
        time: currentTime,
      },
    ],
    joinSession,
    {
      onSuccess: (res) => {
        setJoinResponse(res?.data);
      },
      enabled: Boolean(checkJoinSession),
    }
  );

  const handleReports = (id: any) => {
    setpatientProfileId(id);
    setOpenDialog(true);
  };
  let mode =
    data?.data?.consultationMode.slice(0, 1).toUpperCase() +
    data?.data?.consultationMode.slice(1).toLowerCase();

  const { mutate: statusMutate } = useMutation(updateSession, {
    onSuccess: () => {
      queryClient.invalidateQueries("sessions");
    },
  });

  useEffect(() => {
    setCheckJoinSession(true);
  }, []);

  const startSessionClick = (SessionId: any, clinicianId: any, status: any) => {
    if (joinResponse) {
      if (data?.data?.consultationMode === "HOME") {
        setHomeSession(true);
      } else {
        // For video sessions, just update the status - Google Meet link should already be available
        toast.success("Session started! You can now join using the Google Meet link below.");
      }
      const statusRes = { status: "STARTED" };
      statusMutate({ id: id, body: statusRes });

      // Refetch session data to get any updated meeting links
      setTimeout(() => {
        refetch();
      }, 2000); // Wait 2 seconds then refetch to get updated data
    } else {
      toast.error("Unable to start session. Please try again.");
    }
  };

  const handleComplete = () => {
    const statusRes = { status: "COMPLETED" };
    statusMutate({ id: id, body: statusRes });
    setHomeSession(false);
    if (userJoin === true) {
      newFunc();
    }
  };

  const newFunc = () => {
    const res = {
      sessionId: +id!,
      duration: Math.floor(totalSeconds / 60),
      userType: "CLINICIAN",
    };
    newDuration(res);
  };

  const handlePdfChange = async (event: any, sessionIdValue: string | number) => {
    let fileKeys: string[] = []; // Initialize as an array of strings
    const files = event.target.files;

    if (!files || files.length === 0) {
      toast.error("No files selected.");
      return;
    }
    if (!sessionIdValue) {
      toast.error("Session ID is missing for upload.");
      return;
    }

    for (let i = 0; i < files.length; i++) {
      const currentFile = files[i];
      const formData = new FormData();
      formData.append("file", currentFile);
      formData.append("sessionId", String(sessionIdValue));

      try {
        const response = await axios({
          method: "post",
          url: `${process.env.REACT_APP_API_URL}reports/upload`,
          data: formData,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}` || "",
          },
        });
        if (response?.data?.key) {
          fileKeys.push(response.data.key);
        } else {
          console.warn("File uploaded, but no 'key' found in response data:", response?.data);
        }
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error(`Error uploading file ${currentFile.name}:`, axiosError);
        if (axiosError.response) {
          console.error("Upload - Server Response Data:", JSON.stringify(axiosError.response.data, null, 2));
          console.error("Upload - Server Response Status:", axiosError.response.status);
          console.error("Upload - Server Response Headers:", JSON.stringify(axiosError.response.headers, null, 2));
          const errorData = axiosError.response.data as any;
          toast.error(
            `Failed to upload ${currentFile.name}: ${errorData?.message || errorData?.error || axiosError.message}`
          );
        } else if (axiosError.request) {
          toast.error(
            `Failed to upload ${currentFile.name}: No response from server.`
          );
        } else {
          toast.error(`Failed to upload ${currentFile.name}: ${axiosError.message}`);
        }
      }
    }

    if (fileKeys.length > 0) {
      try {
        const saveData = {
          sessionId: sessionIdValue,
          type: "UPLOAD",
          fileKeys: fileKeys,
        };
        // Make the API call to save report details
        const saveResponse = await axios.post(
          `${process.env.REACT_APP_API_URL}reports/save`,
          saveData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}` || "",
            },
          }
        );
        toast.success(saveResponse?.data?.message || "Report details saved successfully!");
        queryClient.invalidateQueries(["sessions", String(sessionIdValue)]);
        queryClient.invalidateQueries(["reports"]);
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("Error saving report details:", axiosError);
        if (axiosError.response) {
          console.error("Save - Server Response Data:", JSON.stringify(axiosError.response.data, null, 2));
          const errorData = axiosError.response.data as any;
          toast.error(
            `Failed to save report details: ${errorData?.message || errorData?.error || axiosError.message}`
          );
        } else {
          toast.error(
            `Failed to save report details: ${axiosError.message}`
          );
        }
      }
    } else if (files.length > 0) {
      toast.error("No files were successfully uploaded to save.");
    }
  };

  const generateReportClick = () => {
    setOpen(true);
  };

  const handleDownloadMedicalRecord = async (recordId: string) => {
    try {
      const response = await downloadMedicalRecord(parseInt(recordId));
      if (response?.data?.url) {
        window.open(response.data.url, '_blank');
        toast.success("Medical record opened successfully!");
      } else {
        toast.error("Unable to retrieve medical record URL");
      }
    } catch (error: any) {
      console.error("Error downloading medical record:", error);
      toast.error(error?.response?.data?.message || "Failed to download medical record");
    }
  };


  const [minutes] = useState<any>("00");
  const [seconds] = useState("00");

  const interval = useRef<number | null>(null);

  useEffect(() => {

    const intervalId = interval.current;

    return () => {
      if (intervalId !== null) {
        clearInterval(intervalId);
      }
    };
  }, []);

  const [progress, setProgress] = useState(100);

  const calculation = useCallback(() => {
    const remain = 60 - minutes;
    const divide = remain / 60;
    const subtract = 1 - divide;
    const finalTime = Math.floor(subtract * 100);
    return finalTime;
  }, [minutes]);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress(calculation());
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, [progress, calculation]);

  const { mutate: newDuration } = useMutation(postDuration);

  const handleOtp = () => {
    if (data?.data?.otp === +otp) {
      setCheckOtp(true);
      toast.success("OTP verified successfully");
      setUserJoin(true);
    } else {
      setCheckOtp(false);
      toast.error("OTP not verified!");
    }
  };

  useEffect(() => {
    if (userJoin === true) {
      const timer = setTimeout(() => {
        setTotalSeconds(totalSeconds + 1);
      }, 1000);
      return () => clearTimeout(timer);
    }
  });

  return (
    <Box>
      {startSession === false ? (
        <>
          <Box display="flex" gap={1} alignItems="center" sx={{ mt: "50px" }}>
            <ArrowBackIcon
              sx={{ cursor: "pointer" }}
              onClick={() => navigate("/sessions")}
            />
            <Typography variant="h3">Session Details</Typography>
          </Box>

          <Grid container spacing={2} sx={{ height: "80vh" }}>
            {/* <Grid item lg={4} md={5}>
              <Card sx={{ pt: "25px" }}>
                <Typography pb={2} px={2} variant="h4">
                  Other Sessions
                </Typography>
                <Divider />
                <Box
                  p={2}
                  overflow="auto"
                  maxHeight="700px"
                  className="scrollBox"
                >
                  <PendingSessionCard
                    filterData={id}
                    setFilterData={setFilterData}
                  />
                </Box>
              </Card>
            </Grid> */}
            <Grid item xs={12}>
              <Card
                sx={{
                  pt: "25px",
                  height: "100%",
                  width: "100%",
                  overflow: "auto",
                }}
              >
                {/* <Typography pb={2} px={2} variant="h4">
                  Sessions Details
                </Typography> */}
                {/* <Divider /> */}
                {isLoading ? (
                  <Loader />
                ) : (
                  <SessionDetailCard
                    key={id}
                    checkOtp={checkOtp}
                    joinHomeSession={homeSession}
                    otpDate={moment(data?.data?.date).format("DD MMM, YYYY")}
                    minutes={minutes}
                    seconds={seconds}
                    progress={progress}
                    handleOtpClick={handleOtp}
                    otpChange={(e: any) => setOtp(e)}
                    otpValue={otp}
                    patientView={false}
                    statusData={data}
                    sessionId={data?.data?.sessionId}
                    speciality={data?.data?.clinician?.designation}
                    modeOfConsultation={mode}
                    bookedDate={moment(data?.data?.createdAt).format(
                      "DD-MM-YYYY"
                    )}
                    sessionDate={moment(data?.data?.date).format("DD")}
                    sessionMonth={moment(data?.data?.date).format("MMM")}
                    startTime={data?.data?.startAt}
                    endTime={data?.data?.endAt}
                    timeSlots={data?.data?.sessionTimeslot}
                    description={data?.data?.description || "N/A"}
                    doctorImage={data?.data?.clinician?.imageUrl}
                    doctorName={data?.data?.clinician?.users?.fullName}
                    doctorExperience={data?.data?.clinician?.experience}
                    doctorSpeciality={data?.data?.clinician?.designation}
                    patientImage={data?.data?.patients?.imageUrl}
                    patientName={data?.data?.patients?.users?.fullName}
                    patientNumber={data?.data?.patients?.users?.mobileNumber}
                    patientEmail={data?.data?.patients?.users?.email || "N/A"}
                    patientProfileImage={data?.data?.patientProfiles?.imageUrl}
                    PatientProfileName={data?.data?.patientProfiles?.fullName}
                    PatientProfileAge={data?.data?.patientProfiles?.age}
                    PatientProfileGender={data?.data?.patientProfiles?.gender}
                    PatientLandmark={data?.data?.addresses?.landmark}
                    patientAddress1={
                      data?.data?.addresses?.addressLine1 || "N/A"
                    }
                    patientAddress2={
                      data?.data?.addresses?.addressLine2 || "N/A"
                    }
                    PatientCity={data?.data?.addresses?.city}
                    doctorFee={data?.data?.sessionPayment?.clinicianAmount}
                    consultationFee={data?.data?.sessionPayment?.alsanAmount}
                    startSessionClick={() =>
                      startSessionClick(
                        data?.data?.sessionId,
                        data?.data?.clinician?.id,
                        data?.data?.status
                      )
                    }
                    handleReportClick={() =>
                      handleReports(data?.data?.patientProfile?.id)
                    }
                    handleComplete={handleComplete}
                    handlePdfChange={(e: any) =>
                      handlePdfChange(e, data?.data?.id)
                    }
                    generateReportClick={generateReportClick}
                    handleReportsView={() => {
                      navigate(`/reports/${data?.data?.patientProfile?.id}`);
                    }}
                    onRefreshSession={handleRefreshSession}
                  />
                )}
              </Card>
            </Grid>
          </Grid>

          {/* Voice Exercise Summary for this Patient */}
          {data?.data?.patientProfile?.id && (
            <Box sx={{ mt: 2 }}>
              <VoiceExerciseSummary patientProfileId={data.data.patientProfile.id} />
            </Box>
          )}

          <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="md" fullWidth>
            <DialogTitle sx={{ fontSize: "20px" }}>Patient Medical History</DialogTitle>
            <Tabs value={activeTab} onChange={(e, v) => setActiveTab(v)} sx={{ px: 3 }}>
              <Tab label="Session Reports" />
              <Tab label="Uploaded Records" />
            </Tabs>
            <DialogContent sx={{ minHeight: "400px" }} dividers>
              <Box width="100%" height="100%">
                {activeTab === 0 && (
                  // Session Reports Tab
                  <>
                    {!patientHistoryData?.data?.sessions || patientHistoryData?.data?.sessions?.length === 0 ? (
                      <Typography variant="h6" sx={{ opacity: "0.7", textAlign: "center", py: 4 }}>
                        No Session Reports Found
                      </Typography>
                    ) : (
                      <Box>
                        {patientHistoryData?.data?.sessions.map((session: any) => (
                          <Card key={session.id} sx={{ mb: 2, p: 2 }}>
                            <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={1}>
                              <Box>
                                <Typography variant="subtitle1" fontWeight="bold">
                                  Session: {session.sessionId}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                  Date: {new Date(session.date).toLocaleDateString()}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                  Time: {session.startAt} - {session.endAt}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                  Clinician: {session.clinician?.name}
                                </Typography>
                                {session.clinician?.designation && (
                                  <Typography variant="caption" color="text.secondary">
                                    {session.clinician.designation}
                                  </Typography>
                                )}
                              </Box>
                              <Chip
                                label={session.consultationMode}
                                size="small"
                                color="primary"
                                variant="outlined"
                              />
                            </Box>

                            {session.reports && session.reports.length > 0 && (
                              <Box mt={2}>
                                <Typography variant="subtitle2" gutterBottom>
                                  Reports:
                                </Typography>
                                {session.reports.map((report: any) => (
                                  <Box key={report.id} display="flex" alignItems="center" gap={1} mb={1}>
                                    <AssignmentIcon fontSize="small" color="primary" />
                                    <Typography variant="body2" flex={1}>
                                      {report.type} Report ({report.userType})
                                    </Typography>
                                    <a
                                      href={report.fileUrl}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{ textDecoration: "none" }}
                                    >
                                      <Button variant="outlined" size="small">
                                        <DownloadIcon fontSize="small" sx={{ mr: 0.5 }} />
                                        View
                                      </Button>
                                    </a>
                                  </Box>
                                ))}
                              </Box>
                            )}
                          </Card>
                        ))}
                      </Box>
                    )}
                  </>
                )}

                {activeTab === 1 && (
                  // Uploaded Medical Records Tab
                  <>
                    {getMedicalRecordsData?.data?.data?.length === 0 ? (
                      <Typography variant="h6" sx={{ opacity: "0.7", textAlign: "center", py: 4 }}>
                        No Uploaded Medical Records Found
                      </Typography>
                    ) : (
                      <>
                        {getMedicalRecordsData?.data?.data?.map(
                          (reports: any, index: number) => (
                            <Box key={index} mb={2}>
                              <List sx={{ py: 0 }}>
                                <ListItem
                                  sx={{
                                    border: "1px solid",
                                    borderColor: "divider",
                                    borderRadius: 1,
                                  }}
                                  secondaryAction={
                                    <Box>
                                      <a
                                        href={reports?.fileUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ textDecoration: "none" }}
                                      >
                                        <Button variant="outlined" size="small">
                                          <DownloadIcon sx={{ mr: 0.5 }} fontSize="small" />
                                          View
                                        </Button>
                                      </a>
                                    </Box>
                                  }
                                >
                                  <Box
                                    sx={{
                                      backgroundColor: theme.colors.primary.lighter,
                                      p: 1.5,
                                      borderRadius: "30px",
                                      display: "flex",
                                      justifyContent: "center",
                                      mr: 2,
                                    }}
                                  >
                                    <Icon sx={{ color: theme.colors.primary.main }}>
                                      <DescriptionOutlinedIcon />
                                    </Icon>
                                  </Box>
                                  <ListItemText
                                    primary={`Medical Record ${index + 1}`}
                                    secondary={reports?.createdAt ? new Date(reports.createdAt).toLocaleDateString() : "N/A"}
                                  />
                                </ListItem>
                              </List>
                            </Box>
                          )
                        )}
                      </>
                    )}
                  </>
                )}
              </Box>
            </DialogContent>
          </Dialog>
          <Drawer
            anchor="right"
            open={open}
            onClose={() => toggleDrawer(false)}
          >
            <StyledDrawerHeader>
              <Typography>Generate Manual Report</Typography>
              <Typography
                sx={{
                  fontSize: "12px",
                  fontFamily: "Inter_semibold",
                  color: "black",
                  opacity: "0.5",
                  cursor: "pointer",
                }}
                onClick={() => toggleDrawer(false)}
              >
                Cancel
              </Typography>
            </StyledDrawerHeader>
            <StyledDrawerContent>
              <GenerateReportForm
                toggleDrawer={(e: any) => toggleDrawer(e)}
                data={data?.data}
              />
            </StyledDrawerContent>
          </Drawer>
        </>
      ) : (
        <Box sx={{ textAlign: 'center', mt: 4 }}>
          <Typography variant="h5" sx={{ mb: 2 }}>
            Session Started
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            The video session has been started. Use the Google Meet link in the session details to join the meeting.
          </Typography>
          <Button
            variant="contained"
            onClick={() => setStartSession(false)}
            sx={{ mr: 2 }}
          >
            Back to Session Details
          </Button>
          <Button
            variant="outlined"
            onClick={handleComplete}
          >
            Complete Session
          </Button>
        </Box>
      )}
    </Box>
  );
};
